import { PAGE_ICONS } from "./pageIcons.js";

const bodySchema = {
  type: "object",
  properties: {
    eventId: {
      type: "number",
    },
    title: {
      type: "string",
      minLength: 1,
      maxLength: 100,
    },
    type: {
      type: "string",
      enum: ["content", "link"],
    },
    linkUrl: {
      type: "string",
    },
    content: {
      type: "string",
    },
    isDraft: {
      type: "boolean",
    },
    order: {
      type: "number",
    },
    icon: {
      type: "string",
      enum: PAGE_ICONS,
    },
  },
};

export const createPageSchema = {
  body: {
    ...bodySchema,
    required: ["eventId", "title", "type"],
  },
};

export const updatePageSchema = {
  body: {
    ...bodySchema,
  },
};

export const getPagesSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      page: { type: "number" },
      limit: { type: "number" },
      all: { type: "boolean" },
    },
    required: ["eventId"],
  },
};

export const patchPagesOrderSchema = {
  body: {
    type: "object",
    properties: {
      updates: {
        type: "array",
        items: {
          type: "object",
          properties: {
            id: { type: "number" },
            order: { type: "number" },
          },
          required: ["id", "order"],
        },
      },
    },
    required: ["updates"],
  },
};

export const deletePageSchema = {
  body: {
    type: "object",
    properties: {
      id: { type: "string" },
    },
    required: ["id"],
  },
};

export const web_pageFormSchema = {
  type: "object",
  properties: {
    title: { type: "string", minLength: 1 },
    icon: { type: "string", minLength: 1 },
    isDraft: { type: "string", enum: ["true", "false"] },
    type: { type: "string", enum: ["content", "link"] },
    content: { type: "string" },
    linkUrl: {
      type: "string",
      pattern: "^(https?://.*)?$",
    },
  },
  required: ["title", "icon", "isDraft", "type"],
  allOf: [
    {
      if: { properties: { type: { const: "content" } } },
      then: { required: ["content"] },
    },
    {
      if: { properties: { type: { const: "link" } } },
      then: { required: ["linkUrl"] },
    },
  ],
};
